import { render, staticRenderFns } from "./TableSolicitudes.vue?vue&type=template&id=3a21033f&scoped=true"
import script from "./TableSolicitudes.vue?vue&type=script&lang=js"
export * from "./TableSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./TableSolicitudes.vue?vue&type=style&index=0&id=3a21033f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21033f",
  null
  
)

export default component.exports